import { createContext } from 'react';
const JourneyBuilderContext = createContext({
    config: {},
    setConfig: () => {},
});
export default JourneyBuilderContext;
